import { makeActionCreator } from '../../../../utilities'
import { BloodProductAdministrationConstants } from './bloodProductAdministration.constants'

export const setPtIdVerified = makeActionCreator(BloodProductAdministrationConstants.SET_PT_ID_VERIFIED, 'ptIdVerified')
export const setWitness1 = makeActionCreator(BloodProductAdministrationConstants.SET_WITNESS1, 'witness1')
export const setWitness2 = makeActionCreator(BloodProductAdministrationConstants.SET_WITNESS2, 'witness2')
export const setClinicalIndicators = makeActionCreator(
  BloodProductAdministrationConstants.SET_CLINICAL_INDICATORS,
  'clinicalIndicator'
)
export const setTransfusionConsent = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT,
  'transfusionConsent'
)
export const setTransfusionConsentDate = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE,
  'transfusionConsentDate'
)
export const setTransfusionConsentTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_TIME,
  'transfusionConsentTime'
)
export const setTransfusionConsentDateTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE_TIME,
  'transfusionConsentTime',
  'transfusionConsentDate'
)
export const setBloodProduct = makeActionCreator(BloodProductAdministrationConstants.SET_BLOOD_PRODUCT, 'bloodProduct')
export const setBloodProductType = makeActionCreator(
  BloodProductAdministrationConstants.SET_BLOOD_PRODUCT_TYPE,
  'bloodProductType'
)
export const setProductId = makeActionCreator(BloodProductAdministrationConstants.SET_PRODUCT_ID, 'productId')
export const setUnitExpiryDate = makeActionCreator(
  BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE,
  'unitExpDate'
)
export const setUnitExpiryTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_UNIT_EXPIRY_TIME,
  'unitExpTime'
)
export const setUnitExpiryDateTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE_TIME,
  'unitExpTime',
  'unitExpDate'
)
export const setSiteAdministered = makeActionCreator(
  BloodProductAdministrationConstants.SET_SITE_ADMINISTERED,
  'siteAdministered'
)
export const setTransfusionStartDate = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE,
  'transfusionStartDate'
)
export const setTransfusionStartTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_START_TIME,
  'transfusionStartTime'
)
export const setTransfusionStartDateTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE_TIME,
  'transfusionStartTime',
  'transfusionStartDate'
)
export const setTransfusionEndDate = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE,
  'transfusionEndDate'
)
export const setTransfusionEndTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_END_TIME,
  'transfusionEndTime'
)
export const setTransfusionEndDateTime = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE_TIME,
  'transfusionEndTime',
  'transfusionEndDate'
)
export const setVolumeInfused = makeActionCreator(
  BloodProductAdministrationConstants.SET_VOLUME_INFUSED,
  'volumeInfused'
)
export const setVolumeInfusedUnit = makeActionCreator(
  BloodProductAdministrationConstants.SET_VOLUME_INFUSED_UNIT,
  'volumeInfusedUnit'
)
export const setUnitCompleted = makeActionCreator(
  BloodProductAdministrationConstants.SET_UNIT_COMPLETED,
  'unitCompleted'
)
export const setWarmedUsed = makeActionCreator(BloodProductAdministrationConstants.SET_WARMER_USED, 'warmerUsed')
export const setTransfusionOrder = makeActionCreator(
  BloodProductAdministrationConstants.SET_TRANSFUSION_ORDER,
  'transfusionOrder'
)
export const setRoute = makeActionCreator(BloodProductAdministrationConstants.SET_ROUTE, 'route')
export const setCrossMatched = makeActionCreator(BloodProductAdministrationConstants.SET_CROSS_MATCHED, 'crossMatched')
export const setImpliedEmergentConsentReason = makeActionCreator(
  BloodProductAdministrationConstants.SET_IMPLIED_EMERGENT_CONSENT_REASON,
  'impliedEmergentConsentReason'
)

export const resetState = makeActionCreator(BloodProductAdministrationConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(
  BloodProductAdministrationConstants.SET_ADD_TO_TIMELINE,
  'addToTimeline'
)
export const setState = makeActionCreator(
  BloodProductAdministrationConstants.SET_STATE,
  'bloodProductAdministrationState'
)
export const setDate = makeActionCreator(BloodProductAdministrationConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(BloodProductAdministrationConstants.SET_TIME, 'time')
export const setDateTime = makeActionCreator(BloodProductAdministrationConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(BloodProductAdministrationConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectBloodProductAdministrationProcedure = makeActionCreator(
  BloodProductAdministrationConstants.ON_SELECT_BLOOD_PRODUCT_ADMINISTRATION
)
export const setUpdateInputRows = makeActionCreator(
  BloodProductAdministrationConstants.SET_UPDATE_INPUT_ROWS,
  'updateInputRows'
)
export const setSuccessfulAttempt = makeActionCreator(
  BloodProductAdministrationConstants.SET_SUCCESSFUL_ATTEMPT,
  'successfulAttempt'
)
export const setAttempts = makeActionCreator(BloodProductAdministrationConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(
  BloodProductAdministrationConstants.SET_ROLE_PERFORMING,
  'rolePerforming'
)

export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  BloodProductAdministrationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  BloodProductAdministrationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
export const saveBloodProductAdministration = makeActionCreator(
  BloodProductAdministrationConstants.SAVE_BLOOD_PRODUCT_ADMINISTRATION
)
